var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonNeutral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#C691FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0956 36.0586C31.0956 34.896 31.2828 33.9265 31.6572 33.1503C32.0307 32.3741 32.7999 31.5005 33.9649 30.5294C34.7741 29.8311 35.3833 29.1689 35.7923 28.5426C36.2014 27.9164 36.406 27.2105 36.406 26.425C36.406 25.2954 35.9978 24.3548 35.1814 23.6032C34.365 22.8524 33.2494 22.477 31.8346 22.477C30.6839 22.477 29.767 22.7321 29.084 23.2422C28.4011 23.7523 27.8519 24.387 27.4366 25.1463L26 24.5057C26.57 23.4269 27.3321 22.5728 28.2863 21.9431C29.2405 21.3144 30.4233 21 31.8346 21C33.8088 21 35.3304 21.5381 36.3993 22.6143C37.4682 23.6905 38.0018 24.9505 38 26.3945C38 27.3241 37.787 28.1728 37.361 28.9405C36.9342 29.7091 36.3117 30.4395 35.4935 31.1318C34.2681 32.1606 33.4958 32.9995 33.1765 33.6486C32.8582 34.2977 32.699 35.1006 32.699 36.0573L31.0956 36.0586ZM31.8373 43C31.4798 43 31.1681 42.8733 30.9022 42.6199C30.6354 42.3666 30.502 42.0696 30.502 41.7289C30.502 41.3883 30.6354 41.0912 30.9022 40.8379C31.169 40.5845 31.4802 40.4578 31.8359 40.4578C32.1916 40.4578 32.5038 40.5845 32.7723 40.8379C33.0409 41.0912 33.1739 41.3883 33.1712 41.7289C33.1685 42.0696 33.0351 42.3666 32.771 42.6199C32.5069 42.8733 32.1956 43 31.8373 43Z",
    fill: "#C691FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonNeutral);
export default __webpack_public_path__ + "static/media/button-neutral.a9923922e581597cb34ac3b8f7f85fc1.svg";
export { ForwardRef as ReactComponent };